interface GlowOrbProps {
  size?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  animate?: boolean;
  className?: string;
}

const COLOR_MAP: Record<string, string> = {
  primary: 'var(--color-primary-400)',
  secondary: 'var(--color-secondary-400)',
  accent: '#34D399',
  neutral: '#94a3b8',
};

export function GlowOrb({
  size = 120,
  color = 'primary',
  opacity = 0.3,
  animate = false,
  className = '',
}: GlowOrbProps) {
  const uniqueId = `glow-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      className={className}
      style={{
        opacity,
        ...(animate ? { animation: 'float 14s ease-in-out infinite' } : {}),
      }}
    >
      <defs>
        <radialGradient id={uniqueId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={COLOR_MAP[color]} stopOpacity="1" />
          <stop offset="50%" stopColor={COLOR_MAP[color]} stopOpacity="0.4" />
          <stop offset="100%" stopColor={COLOR_MAP[color]} stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx={size / 2} cy={size / 2} r={size / 2} fill={`url(#${uniqueId})`} />
    </svg>
  );
}
